import type { ExtractPublicPropTypes, PropType } from 'vue'
import { tableProps } from '@el-plus/components/table'
import type { PageMode } from '@el-plus/hooks/use-navigation'
import type {Permission} from '@el-plus/directives/permission'
export const attachmentProps = {
  // 格式化列
  formatColumns: {
    ...tableProps.formatColumns,
  },
  // 页面模式
  mode: {
    type: String as PropType<PageMode>,
  },
  // 展示模式
  openType: {
    type: String as PropType<'dialog' | 'normal'>,
    default: 'dialog',
  },
  // 是否需要类型
  isType: {
    type: Boolean,
    default: true,
  },
  // 是否需要备注
  isNote: {
    type: Boolean,
    default: false,
  },
  // 是否需要打开弹窗按钮
  isShowOpenDialogButton: {
    type: Boolean,
    default: false,
  },
  // 添加前校验
  beforeAdd: {
    type: Function as PropType<(fileItem: Record<string, any>) => boolean>,
  },
  // 权限
  permission: {
    type: String as PropType<Permission>,
  },

} as const
export type AttachmentProps = ExtractPublicPropTypes<typeof attachmentProps>
